import { PageHeader } from '@/components/page-header';
import { usePermission, useSession } from '@/features/auth/session';
import { Dashboard } from '@/features/dashboard/dashboard';
import { OnboardingCard, OnboardingWizard } from '@/features/subscription/onboarding';

function greeting() {
  const h = new Date().getHours();
  return h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite';
}

export function HomePage() {
  const { me, membership } = useSession();
  const canSetup = usePermission('settings.manage');
  const first = me?.user.name.split(' ')[0] ?? '';

  return (
    <>
      <PageHeader title={`${greeting()}, ${first}`} description={`Visão geral de ${membership?.organizationName ?? 'sua loja'}.`} className="mb-4" />
      {canSetup && (
        <>
          <OnboardingCard />
          <OnboardingWizard />
        </>
      )}
      <Dashboard />
    </>
  );
}
